import { apiInstance } from "../config/apiInstance"

export const postData = async (url:string, data:any) => {
    const response = await apiInstance.post( url, data );
    return response
}